module.exports = __webpack_public_path__ + "static/media/1-Edit.072f53f0.webp";